import React from 'react';

const StatCard = ({ icon, title, ticker, value, valueColor }) => {
  return (
    <div className="stat-card">
      <div className="card-header">
        {icon}
        <span>{title}</span>
      </div>
      <p className="ticker-label">{ticker}</p>
      <p className={`value-label ${valueColor}`}>{value}</p>
    </div>
  );
};

export default StatCard;